exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".header-card[data-v-4353a312]{top:-30px!important;margin:0 auto;color:#fff;font-size:10px}.card-header[data-v-4353a312]{transition:all .3s ease-in-out}", ""]);

// exports
